import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import GridTab from "./GridTab";
import AddCompany from "./AddCompany";
import ListTab from "./ListTab";
import { connect, useDispatch } from "react-redux";
import { getCompanies } from "../../../store/actions/Companies/companyActions";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { SVGICON } from "../../constant/theme";

const Company = ({ token,companies, companySources }) => {
  const userdata = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCompanies(token));
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Tab.Container defaultActiveKey={"List"}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="heading mb-0">Companies</h4>
              <div className="d-flex align-items-center">
                <Nav
                  as="ul"
                  className="nav nav-pills mix-chart-tab user-m-tabe"
                  id="pills-tab"
                >
                  <Nav.Item as="li" className="nav-item" role="presentation">
                    <Nav.Link
                      as="button"
                      className="nav-link"
                      eventKey={"List"}
                    >
                      {SVGICON.List}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" className="nav-item">
                    <Nav.Link
                      as="button"
                      className="nav-link"
                      eventKey={"Grid"}
                    >
                      {SVGICON.GridDots}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Link
                  to
                  className="btn btn-primary btn-sm ms-2"
                  onClick={() => userdata.current.showEmployeModal()}
                >
                  + Add Company
                </Link>
              </div>
            </div>
            <div className="col-xl-12 active-p">
              <Tab.Content>
                <Tab.Pane eventKey={"Grid"}>
                  <GridTab />
                </Tab.Pane>
                <Tab.Pane eventKey={"List"}>
                  <ListTab title="Company List" />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
      <AddCompany companySources={companySources} ref={userdata} Title="Add Company" token={token} companies={companies}/>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    companies: state.companies.companies || [],
    companySources: state?.dropDownValues?.dropDownValues?.companySources || [],
  };
};

export default withRouter(connect(mapStateToProps)(Company));
